// extracted by mini-css-extract-plugin
export var section = "search-module--section--d6570";